<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>With My Little Eye</title>
<link href="../styles/styles.css" rel="stylesheet" type="text/css"/>
<h3 class="books-by-head1"><em>Recent Titles by Gerald Hammond from Severn House</em></h3>
<p class="books-by-text">COLD IN THE HEADS</p>
<p class="books-by-text">CRASH</p>
<p class="books-by-text">DOWN THE GARDEN PATH</p>
<p class="books-by-text">THE DIRTY DOLLAR</p>
<p class="books-by-text">A DOG’S LIFE</p>
<p class="books-by-text">FINE TUNE</p>
<p class="books-by-text">THE FINGERS OF ONE FOOT</p>
<p class="books-by-text">FLAMESCAPE</p>
<p class="books-by-text">GRAIL FOR SALE</p>
<p class="books-by-text">HIT AND RUN</p>
<p class="books-by-text">THE HITCH</p>
<p class="books-by-text">INTO THE BLUE</p>
<p class="books-by-text">KEEPER TURNED POACHER</p>
<p class="books-by-text">LOVING MEMORY</p>
<p class="books-by-text">ON THE WARPATH</p>
<p class="books-by-text">THE OUTPOST</p>
<p class="books-by-text">A RUNNING JUMP</p>
<p class="books-by-text">SILENT INTRUDER</p>
<p class="books-by-text">THE SNATCH</p>
<p class="books-by-text">WAKING PARTNERS</p>
<p class="books-by-text">WELL AND GOOD</p>
<p class="books-by-text">WITH MY LITTLE EYE</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// alsoby.vue?0d58ba2a